<script lang="ts" setup>
import { defineProps, computed } from 'vue'
import i18n from '@/lang/i18n';

const props = defineProps<{
  requestType: string,
}>()

const isRequest = computed(() => {
  return props.requestType == 'request';
})

const isUpload = computed(() => {
  return props.requestType == 'upload';
})

const className = computed(() => {
  if (isUpload.value) return "upload";
  if (isRequest.value) return "request";
  return "";
})
</script>

<template>
  <template v-if="isRequest">
    <span
      :title="i18n.global.t('pages.cvr_uploads.iconToolTips.request')"
      class="material-symbols-outlined"
      :class="className"
    >
      nest_remote_comfort_sensor
    </span>
  </template>
  <template v-if="isUpload">
    <span
      :title="i18n.global.t('pages.cvr_uploads.iconToolTips.upload')"
      class="material-symbols-outlined"
      :class="className"
    >
      upload
    </span>
  </template>
</template>

<style scoped>
.request {
  color: lightseagreen;
  color: forestgreen;
  color: limegreen;
  font-weight: bold;
}
.upload {
  color: coral;
  font-weight: bold;
}
</style>
